export default [
  { id: 1, name: 'Руководство', regionId: 1 },
  { id: 2, name: 'Департамент закупок', regionId: 1 },
  { id: 3, name: 'Департамент информационных технологий', regionId: 1 },
  { id: 4, name: 'Департамент инновационного развития', regionId: 1 },
  { id: 5, name: 'Департамент специальных проектов', regionId: 1 },
  { id: 6, name: 'Информационно-аналитическая служба', regionId: 1 },
  { id: 7, name: 'Департамент финансов', regionId: 1 },
  { id: 9, name: 'Департамент экономической безопасности', regionId: 1 },
  { id: 10, name: 'Служба по связям с общественностью', regionId: 1 },
  { id: 11, name: 'Департамент регулярных проектов', regionId: 1 },
  { id: 12, name: 'Департамент автоматизации', regionId: 1 },
  { id: 13, name: 'Департамент инвестиционного планирования', regionId: 1 },
  { id: 14, name: 'Департамент развития и новых проектов', regionId: 1 },
  { id: 15, name: 'Тендерный отдел', regionId: 1 },
  { id: 16, name: 'Клиентский отдел', regionId: 1 },
  { id: 17, name: 'Общий отдел', regionId: 1 },
  { id: 18, name: 'Служба формирования и внутреннего аудита цен', regionId: 1 },
  { id: 19, name: 'Департамент по управлению персоналом', regionId: 1 },
  { id: 20, name: 'Департамент развития генной терапии', regionId: 1 },
  { id: 21, name: 'Отдел продаж по г. Москве', regionId: 1 },
  { id: 22, name: 'Отдел продаж по Московской области', regionId: 1 },
  { id: 23, name: 'Дирекция по ФГБУ и ФП', regionId: 1 },
  { id: 24, name: 'Департамент правового обеспечения', regionId: 1 },
  { id: 25, name: 'Департамент продаж медицинского оборудования и расходных материалов', regionId: 2 },
  { id: 26, name: 'Транспортный отдел', regionId: 3 },
  { id: 27, name: 'Отдел учета и претензий', regionId: 3 },
  { id: 28, name: 'Администрация', regionId: 3 },
  { id: 29, name: 'Отдел приема товара', regionId: 3 },
  { id: 30, name: 'Отдел хранения и комплектации', regionId: 3 },
  { id: 31, name: 'Отдел оформления документов', regionId: 3 },
  { id: 32, name: 'Отдел экспедиции', regionId: 3 },
  { id: 33, name: 'Департамент разработки и регистрации ЛС', regionId: 4 },
  { id: 34, name: 'Департамент продаж', regionId: 5 },
  { id: 35, name: 'Департамент продаж', regionId: 6 },
  { id: 36, name: 'Департамент продаж', regionId: 7 },
  { id: 37, name: 'Департамент продаж', regionId: 8 },
  { id: 38, name: 'Департамент продаж', regionId: 9 },
  { id: 39, name: 'Департамент продаж', regionId: 10 },
  { id: 40, name: 'Департамент продаж', regionId: 11 },
  { id: 41, name: 'Департамент продаж', regionId: 12 },
  { id: 42, name: 'Департамент продаж', regionId: 13 },
  { id: 43, name: 'Департамент продаж', regionId: 14 },
  { id: 44, name: 'Техподдержка', regionId: 15 },
];
